var _rect, _rect2, _rect3, _g, _path, _path2, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "#3e5eb9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 250,
    y: 75,
    fill: "#ffd900"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 200,
    y: 100,
    fill: "#b10c0c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd900",
    stroke: "#000",
    strokeWidth: 1.008
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m492.85 154.28-24.285 8.571 24.285 8.571 24.285-8.571-24.285-8.571z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 357.13,
    height: 5.714,
    x: 122.85,
    y: 160,
    rx: 3.106,
    ry: 2.857
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.58 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465.72 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: -23.27,
    y: 17.15
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.08,
    width: 485.7,
    height: 8.571,
    x: 59.812,
    y: 195.72,
    rx: 4.224,
    ry: 4.286
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.008,
    d: "m442.85 200c-28.571 28.569-66.668 85.711-142.86 85.711-66.668 0-114.28-57.142-142.86-85.711 28.571-28.574 76.188-85.716 142.86-85.716 76.188 0 114.28 57.142 142.86 85.716z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m290.02 144.1c7.601 8.549 1.254 11.996 9.3 12.557 8.485 0.623 3.675 9.034 10.812 9.326 4.99 0.218-0.498 20.151 4.305 26.729 4.893 6.857 8.991 2.009 9.077 6.963 0.085 5.124-13.317 4.607-13.552 20.39-0.393 9.096-11.31 9.678-11.831 15.531-0.648 5.505 21.507 8.595 21.211 13.523-0.304 4.913-23.922 4.144-24.95 9.747-0.527 5.033 32.446 9.158 35.098 23.713-4.92 1.609-18.919 3.124-29.499 3.132-66.657 0.048-114.28-57.147-142.85-85.716 28.571-28.574 76.188-85.716 142.86-85.716 0 0-19.789 18.082-9.971 29.815z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    strokeWidth: 6.927
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    strokeWidth: 6.927,
    d: "M213.933 192.377V169.52M227.783 169.52v22.857M241.643 169.52v22.857"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 38.1
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 41.56
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 104.76
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#a70000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3d5da7",
    stroke: "#000",
    strokeWidth: 0.855,
    d: "m511.35 196.6c-4.328 7.496 3.321-2.493 21.985 10.056 3.459 2.331 6.481 8.489 6.481 12.759-0.878-0.587-1.53-1.894-2.497-2.743-1.354 1.357 1.293 7.577 1.68 10.517-2.918-1.633-2.637-2.406-3.606-4.413 0.193 2.426-0.501 9.107 0.66 11.68-2.3-0.657-2.147-2.508-3.348-2.88 0.817 2.912-0.712 6.081-0.306 9.355-1.344-1.33-2.776-2.372-3.4-2.909-0.105 1.559-2.585 5.656-2.641 7.13-1.14-0.689-1.45-1.763-1.64-2.486-1.417 1.781-6.454 8.358-6.777 10.364-3.881-3.428-13.823-11.775-15.117-16.206-1.144 2.515-2.8 3.364-6.073 5.2-1.293-7.022-6.13-14.915-3.543-20.934-1.833 1.087-3.342 2.174-5.174 3.511 1.736-10.17 10.587-22.095 23.319-28.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.21 233.72c1.797-3.592 3.452-4.731 4.613-7.044 2.051-4.065 2.344-7.299 4.131-6.825 1.787 0.474 1.785 2.139-0.53 6.136-2.315 3.997-3.416 4.851-8.214 7.733z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.36 242.28c-0.231-2.735 0.562-3.877 0.418-5.638-0.247-3.099-1.514-5.226 0.134-5.377 1.648-0.151 2.418 0.906 2.423 4.029 0.005 3.123-0.478 3.943-2.974 6.987z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516.58 247.64c-0.72-3.818-0.181-5.511-0.642-7.971-0.802-4.328-2.389-7.177-0.862-7.573 1.527-0.396 2.449 1.004 3.027 5.393 0.578 4.389 0.273 5.595-1.523 10.151z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.17 220.89c-2.252-1.709-3.566-1.824-5.018-2.922-2.558-1.927-3.852-3.99-4.675-2.966-0.823 1.024-0.239 2.144 2.442 3.922 2.68 1.778 3.588 1.918 7.252 1.966z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.58 233.56c-1.187-2.465-2.436-3.09-3.204-4.676-1.357-2.787-1.359-5.198-2.831-4.58-1.472 0.618-1.59 1.88-0.016 4.578 1.574 2.697 2.398 3.186 6.051 4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d5da7",
    stroke: "#000",
    strokeWidth: 1.067,
    d: "m80.783 203.82c-0.242-2.183 0.225-2.444-1.118-4.09 1.955 0.818 2.029 2.992 4.406 1.449 0.873-0.452 1.254-0.466 0.193-2.891 2.479 0.115 10.596 2.899 11.896 2.963 3.413 0.157 9.644-3.586 13.969 1.016 4.151 4.196 2.765 8.551 2.765 14.362-1.668-0.799-0.864-1.193-2.634-3.271 1.327 5.079-0.071 14.237-0.071 19.624-0.681-1.299-0.581-0.735-1.247-2.08-1.77 4.917-3.891 5.929-3.891 11.74-0.639-2.279-0.022-1.797-0.733-2.996-1.72 3.733-13.26 6.923-8.813 10.686-4.014-2.353-5.774-2.106-7.594-4.223-0.784 0.506-1.407 1.464-2.136 2.777-7.057-3.247-4.534-10.25-10.062-14.928-0.957 1.961-0.521 1.677-1.555 4.869-1.119-4.434-1.425-7.251-2.684-10.511-1.086 1.807-0.989 1.114-2.961 3.845-0.816-5.401-2.144-6.676-1.619-10.25-2.096 1.479-0.724 0.88-2.819 2.7 1.985-13.84 10.558-24.067 16.71-20.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.101 226.41c1.818-4.456 3.457-5.855 4.632-8.724 2.075-5.042 2.413-9.073 4.156-8.458 1.743 0.615 1.715 2.691-0.617 7.645-2.332 4.955-3.423 6.005-8.171 9.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.985 237.56c0.729-3.995 1.879-5.45 2.352-8.023 0.839-4.524 0.371-7.893 1.991-7.715 1.62 0.177 1.986 1.885 0.908 6.385-1.078 4.501-1.822 5.566-5.252 9.353z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.219 245.31c0.205-3.873 1.113-5.385 1.249-7.88 0.246-4.388-0.599-7.529 0.946-7.547 1.545-0.018 2.095 1.56 1.622 5.953-0.473 4.393-1.045 5.489-3.817 9.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.9 219.98c-3.381-3.368-5.425-3.997-7.606-6.163-3.842-3.804-5.698-7.376-7.066-6.11s-0.545 3.164 3.5 6.784c4.045 3.62 5.452 4.148 11.172 5.489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.84 233c-2.202-3.382-3.818-4.258-5.24-6.434-2.507-3.824-3.369-7.11-4.79-6.296-1.422 0.814-1.104 2.531 1.613 6.238 2.717 3.706 3.81 4.388 8.417 6.493z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d5da7",
    stroke: "#000",
    strokeWidth: 0.826,
    d: "m253.8 129.5c-3.958 7.655 6.93-2.546 23.998 10.269 3.163 2.381 7.697 11.787 7.697 16.147-3.634-0.773-10.069-4.36-10.069-4.36s7.552 7.564 7.552 16.284c-2.668-1.668-4.003-1.418-4.89-3.466 0 2.823 2.373 4.622 2.373 8.982-1.926-1.537-3.557-2.561-5.186-3.46 2.517 4.36-4.587 12.818-1.032 15.641-6.218-0.899-12.58-4.872-15.097-9.232-1.334 0.899-1.479 2.311-1.531 3.816 0.196 0.163-9.465-7.171-8.577-9.988-1.296 1.818-1.478 2.817-1.774 4.866-3.549-3.5-6.802-7-7.986-11.525-1.577 2.049-1.676 2.049-3.253 4.098-1.183-7.171-1.183-6.915 1.183-13.061-1.676 1.11-3.056 2.22-4.732 3.586 1.587-10.385 9.682-22.563 21.325-28.594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.04 166.9c0.633-5.275 2.012-7.262 2.424-10.659 0.735-5.974-0.137-10.341 1.98-10.23 2.117 0.11 2.727 2.314 1.68 8.276-1.046 5.961-1.929 7.409-6.084 12.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.09 176.56c-0.429-4.45 0.393-6.345 0.12-9.212-0.47-5.044-2.028-8.461-0.183-8.775 1.845-0.314 2.778 1.378 2.977 6.471 0.199 5.093-0.294 6.45-2.915 11.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.34 184.44c-1.876-3.851-3.488-4.999-4.699-7.478-2.139-4.356-2.586-7.913-4.236-7.269-1.65 0.645-1.559 2.485 0.824 6.749 2.383 4.264 3.46 5.134 8.111 7.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.31 149.95c-4.778-2.515-7.232-2.547-10.311-4.163-5.422-2.834-8.578-6.035-9.698-4.273-1.121 1.762 0.375 3.514 5.965 6.09 5.59 2.576 7.307 2.698 14.045 2.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.06 164.36c-3.479-2.894-5.536-3.32-7.78-5.182-3.953-3.267-5.92-6.476-7.241-5.175-1.32 1.301-0.438 3.019 3.711 6.097 4.149 3.078 5.568 3.46 11.31 4.26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.f2cba9b21cb0aa244085d8b5be63bc0d.svg";
export { ForwardRef as ReactComponent };